export const GET_UNCONFIRMED_EMPLOYEES = 'GET_UNCONFIRMED_EMPLOYEES';
